// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"bc28d989","658":"e369cfeb"}[chunkId] + ".chunk.js";
};